import React from 'react';

const FilterOdometerIcon = (props: any) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M15 14.4713H17.0833C17.3533 13.6975 17.5 12.8659 17.5 12C17.5 7.85788 14.1421 4.50002 10 4.50002C5.85786 4.50002 2.5 7.85788 2.5 12C2.5 12.8659 2.64672 13.6975 2.91667 14.4713H5"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M10 4.83337L10 6.50004" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M5 6.50003L6.17851 7.67854" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M14.512 6.50003L13.5497 7.86086" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M3.33325 10.6667L4.9746 10.9561" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M16.6667 10.6667H15.0001" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M9.16659 14.8334L10.8333 10.3333" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default FilterOdometerIcon;
